import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { City } from "../../../types/city.types";

interface CityDetailsModalProps {
  city: City;
  onClose: () => void;
  onToggleAvailability: (city: City) => void;
}

export const CityDetailsModal = ({
  city,
  onClose,
  onToggleAvailability,
}: CityDetailsModalProps) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
      <div className="w-full max-w-md bg-popupLight dark:bg-popupDark rounded-lg shadow-2xl p-6 relative">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
        >
          <X size={18} />
        </button>

        <h2 className="text-xl font-semibold mb-4 dark:text-primaryTextDark text-primaryText">
          {t("City Details")}
        </h2>

        <div className="flex flex-col gap-3 text-sm">
          <div>
            <span className="font-medium">{t("City")}:</span> {city.city}
          </div>
          <div>
            <span className="font-medium">{t("Country")}:</span> {city.country}
          </div>
          <div>
            <span className="font-medium">{t("Latitude")}:</span> {city.lat}
          </div>

          <div>
            <span className="font-medium">{t("Longitude")}:</span> {city.lng}
          </div>
          <div>
            <span className="font-medium">{t("Status")}:</span>{" "}
            <span
              className={
                city.isAvailable
                  ? "text-green-600 dark:text-green-400"
                  : "text-red-600 dark:text-red-400"
              }
            >
              {city.isAvailable ? t("Active") : t("Inactive")}
            </span>
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            onClick={() => onToggleAvailability(city)}
            className={`px-4 py-2 rounded text-sm font-medium transition ${
              city.isAvailable
                ? "bg-red-500 hover:bg-red-600 text-white"
                : "bg-green-600 hover:bg-green-700 text-white"
            }`}
          >
            {city.isAvailable ? t("Make Inactive") : t("Make Active")}
          </button>
        </div>
      </div>
    </div>
  );
};
